import { render } from "./CampaignsDetailPerformancePerStore.vue?vue&type=template&id=38bf1c7a&scoped=true"
import script from "./CampaignsDetailPerformancePerStore.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailPerformancePerStore.vue?vue&type=script&lang=js"

import "./CampaignsDetailPerformancePerStore.vue?vue&type=style&index=0&id=38bf1c7a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bf1c7a"]])

export default __exports__